import { FC } from "react";
import cn from "classnames";

const CURRENCY = "$";

interface Props {
  className?: string;
  price: number;
}

export const CardPrice: FC<Props> = ({ className, price }) => (
  <p
    className={cn(
      "flex gap-1 text-purple-base text-xl font-semibold",
      className
    )}
  >
    <span>{CURRENCY}</span>
    <span>{price.toLocaleString()}</span>
  </p>
);
